import React, { Component } from "react";
import { Consumer } from "../../context/index";
import Request from "../../utils/http";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
const request = new Request();
class GeneralInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            page: 0,
            rowsPerPage: 25,
            codigo: "",
            tipo: "",
            nombre: "",
            bodega: "",
            estado: "",
            user: {
                id: 0,
                id_perfil: 0,
                name: "",
            },
        };
    }

    componentDidMount() {
        this.load();
        this.loadInventario();

    }
    async load() {
        const user = await this.props.context.loadUser();

        if (user) {
            this.setState({
                user: user,
            });
        }
    }

    async loadInventario() {
        try {
            let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
            let token;
            if (token1) {
                token = token1.id;
            }
            let data = {
                token: token,
                band: 1,
                idPerfil: this.state.user.id_perfil,
            };

            const response = await request.post("/auth/inventory/getGeneralInventory", data);
            console.log(response);

            const result = response.result.result;

            this.setState({
                data: result || [],
                loading: false,
            });
        } catch (error) {
            console.error("Error cargando inventario:", error);
            this.setState({ loading: false });
        }
    }
    async handleChangeFilter(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
        });
    }
    handleClear() {
        this.setState({
            codigo: "",
            nombre: "",
            tipo: "",
            bodega: "%",
            estado: "%",
            loading: true,
        });
        this.loadInventario();
    }
    async handleSearch() {
        try {
            this.setState({ loading: true });
            let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
            let token;
            if (token1) {
                token = token1.id;
            }
            let data = {
                token: token,
                band: 1,
                idPerfil: this.state.user.id_perfil,
                codigo: this.state.codigo || "",
                nombre: this.state.nombre || "",
                tipo: this.state.tipo || "",
                bodega: this.state.bodega || "%",
                estado: this.state.estado || "%"
            };

            const response = await request.post("/auth/inventory/buscarGeneralInventory", data);
            const result = response.result.result
            this.setState({
                data: result || [],
                loading: false,
            });

        } catch (error) {
            console.error("Error al buscar inventario:", error);

            this.setState({
                loading: false,
                data: [],
            });
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        });
    };
    renderFechas(value) {
        if (!value) return "";

        let fechas = JSON.parse(value);

        return fechas.join(" , ");
    }
    render() {
        const { data, loading, page, rowsPerPage } = this.state;

        return (
            <div className="content-wrapper" id="tableBodega">
                <div className="card" style={{ margin: "1rem" }}>
                    <div className="card-header">
                        <div
                            className="card-title row "
                            style={{ width: "100%" }}
                        >
                            {/* CÓDIGO */}
                            <div className="col text-center">
                                <TextField
                                    label="Código"
                                    name="codigo"
                                    value={this.state.codigo}
                                    onChange={(e) => this.handleChangeFilter(e)}
                                />
                            </div>

                            {/* NOMBRE */}
                            <div className="col text-center">
                                <TextField
                                    label="Nombre"
                                    name="nombre"
                                    value={this.state.nombre}
                                    onChange={(e) => this.handleChangeFilter(e)}
                                />
                            </div>

                            {/* TIPO DE ARTÍCULO */}
                            <div className="col text-center">
                                <TextField
                                    label="Tipo de Artículo"
                                    name="tipo"
                                    value={this.state.tipo}
                                    onChange={(e) => this.handleChangeFilter(e)}
                                />
                            </div>

                            {/* BODEGA ORIGEN */}
                            <div className="col text-center">
                                <FormControl style={{ minWidth: 160 }}>
                                    <InputLabel htmlFor="bodega">Bodega</InputLabel>
                                    <Select
                                        value={this.state.bodega}
                                        onChange={(e) => this.handleChangeFilter(e)}
                                        input={<Input id="bodega" />}
                                        name="bodega"
                                    >
                                        <MenuItem value="%">Todas</MenuItem>
                                        <MenuItem value="BONFIL">Bonfil</MenuItem>
                                        <MenuItem value="CEDIS">CEDIS</MenuItem>
                                        <MenuItem value="PUERTO">Puerto</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* ESTADO */}
                            <div className="col text-center">
                                <FormControl style={{ minWidth: 160 }}>
                                    <InputLabel htmlFor="estado">Estado</InputLabel>
                                    <Select
                                        value={this.state.estado}
                                        onChange={(e) => this.handleChangeFilter(e)}
                                        input={<Input id="estado" />}
                                        name="estado"
                                    >
                                        <MenuItem value="%">Todos</MenuItem>
                                        <MenuItem value="DISPONIBLE">Disponible</MenuItem>
                                        <MenuItem value="TRASLADO">Traslado</MenuItem>
                                        <MenuItem value="MANTENIMIENTO">Mantenimiento</MenuItem>
                                        <MenuItem value="TERMINADO">Terminado</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>


                            {/* BOTONES */}
                            <div className="col">
                                <button
                                    className="btn btn-primary btn-sm button-filter"
                                    onClick={this.handleSearch.bind(this)}
                                >
                                    <i className="fas fa-search"></i>
                                </button>
                                &nbsp;
                                <button
                                    className="btn btn-secondary btn-sm button-filter"
                                    onClick={this.handleClear.bind(this)}
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body" style={{ margin: "1rem", padding: "1rem" }}>
                        {loading ? (
                            <div style={{ textAlign: "center", padding: "2rem" }}>
                                <CircularProgress />
                                <p>Cargando inventario...</p>
                            </div>
                        ) : (
                            <>
                                <TableContainer style={{ overflowX: "auto" }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#</TableCell>
                                                <TableCell>CÓDIGO</TableCell>
                                                <TableCell>NOMBRE</TableCell>
                                                <TableCell>TIPO ARTÍCULO</TableCell>
                                                <TableCell>FOTO</TableCell>
                                                <TableCell>DESCRIPCIÓN</TableCell>
                                                <TableCell>TOTAL</TableCell>
                                                <TableCell>DISPONIBLE</TableCell>
                                                <TableCell>COSTO UNIT.</TableCell>
                                                <TableCell>COSTO TOTAL</TableCell>
                                                <TableCell>BODEGA ORIGEN</TableCell>
                                                <TableCell>UBICACIÓN</TableCell>
                                                <TableCell>NOTAS</TableCell>
                                                <TableCell>ÚLTIMO USO</TableCell>
                                                <TableCell>ESTADO</TableCell>
                                                <TableCell>EN USO</TableCell>
                                                <TableCell>MANTENIMIENTO</TableCell>
                                                <TableCell>HISTORIAL</TableCell>
                                                <TableCell>TIPO ALMACÉN</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {data
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={row.codigo || index}>
                                                        <TableCell>{row.numero}</TableCell>
                                                        <TableCell>{row.codigo}</TableCell>
                                                        <TableCell>{row.nombre}</TableCell>
                                                        <TableCell>{row.tipo_articulo}</TableCell>

                                                        <TableCell>
                                                            {row.foto_url ? (
                                                                <img
                                                                    src={row.foto_url}
                                                                    alt="foto"
                                                                    style={{ maxHeight: 60 }}
                                                                    onError={(e) => {
                                                                        e.target.style.display = "none";
                                                                    }}
                                                                />
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </TableCell>

                                                        <TableCell
                                                            style={{
                                                                maxWidth: 250,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                            title={row.descripcion}
                                                        >
                                                            {row.descripcion}
                                                        </TableCell>

                                                        <TableCell>{row.cantidad_total}</TableCell>
                                                        <TableCell>{row.cantidad_disponible}</TableCell>
                                                        <TableCell>${row.costo_unitario}</TableCell>
                                                        <TableCell>${row.costo_total_stock}</TableCell>
                                                        <TableCell>{row.bodega_origen}</TableCell>
                                                        <TableCell>{row.ubicacion_bodega}</TableCell>

                                                        <TableCell
                                                            style={{
                                                                maxWidth: 200,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                            title={row.notas_adicionales}
                                                        >
                                                            {row.notas_adicionales}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {this.renderFechas(row.fecha_ultimo_uso)}
                                                        </TableCell>
                                                        <TableCell>{row.estado}</TableCell>
                                                        <TableCell>{row.cantidad_en_uso}</TableCell>
                                                        <TableCell>{row.cantidad_mantenimiento}</TableCell>

                                                        <TableCell
                                                            style={{
                                                                maxWidth: 250,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                            title={row.historial_novedades}
                                                        >
                                                            {row.historial_novedades}
                                                        </TableCell>

                                                        <TableCell>{row.tipo_almacen}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 100, 200]}
                                    component="div"
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    labelRowsPerPage="Registros por página"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Consumer(GeneralInventory);
